/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import logo from '../../Recursos/logo_oscuro.svg'
import {SECCIONES, URLAPPUSUARIO} from "../../Constantes";
import {useNavigate} from "react-router-dom";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {LoginOutlined,AccountCircleOutlined} from '@mui/icons-material'
import {theme} from "../../Tema";
import {irUrl} from "../../Utilidades/irUrl";

const BarraPc = ({valor}) => {
    const navigate = useNavigate();
    const {ir} = useIrRuta()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 3, borderBottom: 1, borderColor: '#00000090'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                    <img src={logo} width={180} height={'auto'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {SECCIONES.map((item, index) => (
                            <Typography
                                onClick={() => ir(item)}
                                sx={{cursor: 'pointer'}}
                            >
                                {item}
                            </Typography>
                        ))}

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-end'}} spacing={1}>

                    <Button
                        onClick={() => irUrl(URLAPPUSUARIO+'?id=ingreso')}
                        variant={'outlined'} endIcon={<AccountCircleOutlined/>} sx={{px: 4, color: theme.palette.primary.main}}>
                        Ingresar
                    </Button>

                    <Button
                        onClick={() => irUrl(URLAPPUSUARIO+'?id=registro')}
                        endIcon={<LoginOutlined/>} sx={{px: 4, color: '#fff'}}>
                        Registro
                    </Button>



                </Grid>


            </Grid>

        </Grid>
    )

}
export default BarraPc